function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classNames from "classnames";
import VisibilitySensor from "react-visibility-sensor";
import { scrollTo } from "/services/dom-utils-service";
import { trackEvent } from "/services/bigbrain-service";
import { FREQUENTLY_ASKED_QUESTION_CLICKED, PRICING_PAGE_FAQ_QUESTIONS_BUTTON_CLICK, PRICING_PAGE_FAQ_SECTION_VISIBLE } from "/constants/bigbrain-event-types";
import FaqQuestion from "segments/desktop/core-components/faq-question/faq-question";
import Title from "segments/desktop/core-components/title/title";
import { isDarkTheme } from "segments/segments-service";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { withGenericConfig } from "contexts/generic-config-context";
import DefaultProps from "./default-props";
import { StyledFrequentlyAskedQuestionsPricingComponent } from "./frequently-asked-questions-pricing-component.scss";
const NO_QUESTION_OPEN_INDEX = -1;
class FrequentlyAskedQuestionsPricingComponent extends PureComponent {
    renderGoToFaqButton() {
        const { translate, hideQuestionsJumpToShortCut } = this.props;
        const { showGoToFaq } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            role: "button",
            tabIndex: "0",
            className: classNames("go-to-faq-with-arrow", {
                visible: !hideQuestionsJumpToShortCut && showGoToFaq
            }),
            onClick: this.scrollToFaq,
            tabIndex: -1,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "go-to-faq-button",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "text",
                        children: translate("pricingPage.faq.questions")
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "down-arrow-wrapper"
                })
            ]
        });
    }
    render() {
        const { questions, title, translate, titleSize, titleColor } = this.props;
        const titleProps = {
            title: translate(title),
            titleSize,
            titleColor
        };
        return /*#__PURE__*/ _jsxs(StyledFrequentlyAskedQuestionsPricingComponent, {
            className: "frequently-asked-questions-pricing-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "frequently-asked-questions-title",
                    children: /*#__PURE__*/ _jsx(Title, _object_spread({}, titleProps))
                }),
                this.renderGoToFaqButton(),
                /*#__PURE__*/ _jsx(VisibilitySensor, {
                    minTopValue: 200,
                    partialVisibility: true,
                    onChange: this.onVisibilityChange,
                    active: true,
                    scrollCheck: true,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "faqs-container",
                        children: questions && this.renderQuestions()
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "questionClicked", (faqs, index)=>{
            var _faqs_index, _faqs_index1;
            const { openedQuestionIndex } = this.state;
            const closingQuestion = openedQuestionIndex === index;
            if (closingQuestion) {
                //close question
                this.setState({
                    openedQuestionIndex: NO_QUESTION_OPEN_INDEX
                });
            } else {
                //open question
                this.setState({
                    openedQuestionIndex: index
                });
            }
            fireGtmEvent(DataLayerEventTypes.FAQ_ACCORDION, {
                click_text: (_faqs_index = faqs[index]) === null || _faqs_index === void 0 ? void 0 : _faqs_index.question,
                isOpen: !closingQuestion
            });
            trackEvent(FREQUENTLY_ASKED_QUESTION_CLICKED, {
                info2: closingQuestion ? "closed" : "opened",
                info3: faqs[index] && ((_faqs_index1 = faqs[index]) === null || _faqs_index1 === void 0 ? void 0 : _faqs_index1.question)
            });
        });
        _define_property(this, "getQuestionID", (question)=>{
            return `faq_question_${question}`;
        });
        _define_property(this, "getAnswerID", (question)=>{
            return `faq_answer_${question}`;
        });
        _define_property(this, "scrollToFaq", ()=>{
            const { clusterId } = this.props;
            if (this._faqSection) {
                trackEvent(PRICING_PAGE_FAQ_QUESTIONS_BUTTON_CLICK, {
                    info1: clusterId
                });
                scrollTo(this._faqSection.offsetTop - 200, 600);
            }
        });
        _define_property(this, "renderQuestions", ()=>{
            const { questions, translate, questionSize, answerSize, theme } = this.props;
            const { openedQuestionIndex } = this.state;
            return /*#__PURE__*/ _jsx("ul", {
                className: "faq-list",
                ref: (el)=>this._faqSection = el,
                children: questions.map((questionObject, index)=>{
                    const { question, answer } = questionObject;
                    const isOpen = openedQuestionIndex === index;
                    const questionId = this.getQuestionID(question);
                    const answerId = this.getAnswerID(question);
                    const displayedAnswer = translate(answer);
                    return /*#__PURE__*/ _jsxs("li", {
                        className: "faq-list-item",
                        children: [
                            /*#__PURE__*/ _jsx(FaqQuestion, {
                                question: question,
                                answer: answer,
                                index: index,
                                isOpen: isOpen,
                                answerId: answerId,
                                questionId: questionId,
                                faqQuestionClickedCallback: (index)=>this.questionClicked(questions, index),
                                questionSize: questionSize,
                                theme: theme
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: classNames("faq-answer-item", answerSize, {
                                    open: isOpen,
                                    "dark-theme": isDarkTheme(theme)
                                }),
                                id: answerId,
                                role: "region",
                                "aria-labelledby": questionId,
                                tabIndex: 0,
                                dangerouslySetInnerHTML: {
                                    __html: displayedAnswer
                                }
                            })
                        ]
                    }, index);
                })
            });
        });
        _define_property(this, "onVisibilityChange", (visible, data)=>{
            const { clusterId } = this.props;
            const { showGoToFaq } = this.state;
            if (visible) {
                trackEvent(PRICING_PAGE_FAQ_SECTION_VISIBLE, {
                    info1: clusterId
                });
            }
            // showing goto button only if faq seciton is not visible and is below us
            const newShowGoToFaq = !visible && data.top;
            if (showGoToFaq != newShowGoToFaq) {
                this.setState({
                    showGoToFaq: newShowGoToFaq
                });
            }
        });
        this._faqSection = null;
        this.state = {
            openedQuestionIndex: NO_QUESTION_OPEN_INDEX,
            showGoToFaq: true
        };
    }
}
FrequentlyAskedQuestionsPricingComponent.defaultProps = DefaultProps;
export default withGenericConfig(FrequentlyAskedQuestionsPricingComponent);
